/*
* Description: Main App Component
*
* History:
*   01/18/2022  A Kuprion ITMFG-27821 Angular Upgrade, version from appinfoservice and clean up unused methods
**/
import { Component, Inject} from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { appinfo } from './appinfo';
import { filter } from 'rxjs/operators';
import { TpmService } from "src/app/dashboard/services/tpm.service";
import {​​​​ GeaMesCognitoAuthService }​​​​ from '@gea-mes/cognito';
import { Subscription} from 'rxjs';
import { GEA_MES_NAVBAR_MENU_SERVICE, NavItem, GeaMesNavbarModule } from '@gea-mes/navbar';
import { NavItemService } from './services/nav-item.service';
import { BehaviorSubject } from 'rxjs';
import { ProgressSpinnerComponent } from './dashboard/components/progress-spinner/progress-spinner.component';

declare var gtag_setValue; // Declare function defined in index.html


const APP_TITLE:string = 'TPM Checklist';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [GeaMesNavbarModule, ProgressSpinnerComponent, RouterOutlet]
})
export class AppComponent  {
  title:string = APP_TITLE;
  subtitle:string = APP_TITLE;
  productionMode: boolean;
  trackingid:string;
  userTitle:string;
  userDivision:string;
  logon$: Subscription;

  constructor (
    private router: Router,
    private tpmService: TpmService,
    private geaMesCognito: GeaMesCognitoAuthService,
    public navService:NavItemService,
    @Inject(GEA_MES_NAVBAR_MENU_SERVICE) private NavItem: BehaviorSubject<NavItem[]>    
  )
  {
    this.NavItem.next(navService.navItems);

    const navEndEvent$ = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      this.tpmService.isLoading.next(false);
    });

    console.log("Version: ", appinfo.version)

  }

  ngOnInit(): void {
    this.productionMode = environment.production
    console.log(this.productionMode)

    gtag_setValue({"appversion": appinfo.version});

    this.logon$ = this.geaMesCognito.sessionEstablished$.subscribe( out => {
      this.trackingid = this.geaMesCognito.getUserAttribute("trackingid");
      this.userTitle = this.geaMesCognito.getUserAttribute("title");
      this.userDivision = this.geaMesCognito.getUserAttribute("division");
      if (this.trackingid != undefined) {
        gtag_setValue({"sub": this.trackingid});
        gtag_setValue({"title": this.userTitle});
        gtag_setValue({"division": this.userDivision});
        if (this.logon$) this.logon$.unsubscribe(); // We've done the work we need to, can unsubscribe
      }       
    });
  }
}
